module.exports = __webpack_public_path__ + "img/planta_06.d912bfe8.png";